import { Skeleton, Spin } from 'antd'
import { Empty, EmptyText, ScrollBar } from 'components/CommonStyles'
import Flex from 'components/Flex'
import SearchInput from 'components/SearchInput'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
const LocationFilter = ({
  locationValue,
  setLocationValue,
  singleRoleData,
  setLocationSearch,
  locationSearch,
  locationLoading = false,
  loadMore,
}) => {
  const [locationOptions, setLocationOptions] = useState([])

  useEffect(() => {
    const locations = singleRoleData?.result?.map(item => {
      return {
        label: item?.city,
        value: item?.city,
      }
    })
    setLocationOptions(locations)
  }, [singleRoleData])
  return (
    <Wrapper column>
      <div
        style={{
          position: 'sticky',
          background: 'white',
          zIndex: 1,
        }}
      >
        <SearchInput
          width={'100%'}
          placeholder={'Search by keyword'}
          searchValue={locationSearch}
          setSearchValue={setLocationSearch}
        />
      </div>
      {singleRoleData?.result?.length ? (
        <ScrollBar id="scrollableDiv" height={'28vh'}>
          <InfiniteScroll
            dataLength={singleRoleData?.result?.length}
            next={loadMore}
            hasMore={singleRoleData?.result?.length < singleRoleData?.count}
            loader={
              <Flex center>
                <Spin small />
              </Flex>
            }
            scrollableTarget="scrollableDiv"
          >
            <FilterCheckBoxComp
              value={locationValue}
              options={locationOptions}
              onChange={values =>
                setLocationValue([values[values?.length - 1]])
              }
            />
          </InfiniteScroll>
        </ScrollBar>
      ) : locationLoading ? (
        <Flex spaceBetween centerVertically>
          <Skeleton
            active
            paragraph={{ rows: 1 }}
            title={false}
            avatar={{ size: 'small', shape: 'square' }}
            style={{ marginTop: '10px' }}
          >
            <StyledCheckbox />
          </Skeleton>
        </Flex>
      ) : (
        <Empty
          padding={'50px 0px 0px 0px'}
          height={'75px'}
          description={<EmptyText size={'9px'}>No Location found!</EmptyText>}
        />
      )}
    </Wrapper>
  )
}

export default LocationFilter
